export default __webpack_public_path__ + "static/media/photo_5282747746622312890_y.7da59f67.jpg";